import Icons from '@/const/icons';
import { WelcomeStep } from '@/interfaces';

export const WELCOME_STEPS: WelcomeStep[] = [
	{
		number: 1,
		iconSrc: Icons.identificationCard,
		title: 'Identity Verification',
		description: 'Confirm your personal details match your case record.',
		badgeClassName: 'bg-blue-link/15 text-main-blue-dark',
	},
	{
		number: 2,
		iconSrc: Icons.fileAlt,
		title: 'Upload Documents',
		description:
			'Provide the identification documents required to process your claim.',
		badgeClassName: 'bg-purple-150/15 text-purple-150',
	},
];

export const NEW_ACCOUNT_WINDOW_HOURS = 72;
